<template>
  <div>
    <div class="d-flex align-items-center mb-4">
      <div class="mr-auto">
        <h1 class="d-inline">My campaigns</h1>
        <router-link
          :to="{ name: 'campaign-add' }"
          class="text-primary title-link ml-3"
          v-b-tooltip.hover
          title="Add new campaign"
        >
          <svg-icon icon="plus-round" class="icon-lg" />
        </router-link>
      </div>
    </div>
    <template v-if="campaignsList">
      <filter-campaigns />
      <list-campaigns :list="campaignsList" :totals="campaignsList.totals" />
    </template>
  </div>
</template>

<script>
import ListCampaigns from './components/ListCampaigns.vue';
import FilterCampaigns from './components/FilterCampaigns.vue';
import { loadingMixin } from '@/utils/mixins.js';
import { mapGetters } from 'vuex';

export default {
  components: {
    FilterCampaigns,
    ListCampaigns
  },

  head() {
    return {
      title() {
        return {
          inner: this.$t('campaigns')
        };
      }
    };
  },

  mixins: [loadingMixin],

  data() {
    return {
      filters: {}
    };
  },

  computed: {
    userId() {
      return this.$store.getters.user.id;
    },
    ...mapGetters({
      campaignsList: 'advert/advertCampaigns'
    })
  },

  methods: {
    loadCampaigns() {
      if (this.isLoading) return;
      this.isLoading = true;

      this.$store.dispatch('advert/fetchAdvertCampaigns', this.userId).then(
        () => {
          this.isLoading = false;
        },
        e => {
          this.isLoading = false;
          if (this.campaignsList.length === 0) {
            this.$store.commit('SET_PAGE_FAILURE', e);
          }
        }
      );
    }
    // updateFilters(filters) {
    //   this.filters = filters;
    //   this.$store.commit('advert/SET_ADVERT_CAMPAIGNS', []);
    //   this.loadCampaigns();
    // }
  },

  created() {
    this.loadCampaigns();
  }
};
</script>

<style lang="scss" scoped>
.title-link {
  position: relative;
  top: -2px;
}
</style>
